// extracted by mini-css-extract-plugin
module.exports = {"caption":"home_caption__39Eul","order-description":"home_order-description__3-9be","order-paragraph":"home_order-paragraph__CpN44","order-title":"home_order-title__164Vv"};